import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import SideBar from "../Admin/SideBar";

const ProtectedRoute = ({ auth, children }) => {

  if (auth === false) {
    return <Navigate to="/login" />;
  }
 // return children ? children : <Outlet />;

 return(
  <div className="d-flex justify-content-start h-100">
  <div>
    <SideBar />
  </div>
  <div className="p-4 pageContainer">
   <Outlet />
  </div>
</div>
 );
  
};

export default ProtectedRoute;
